import { withHeadlessPage } from './headless-render.js'

export const pdf = async ({
  id = '',
  model = null,
  data = null,
  width = 0,
  height = 0,
  options = {} as any,
  context = {} as any
} = {}) => {
  return withHeadlessPage(
    { id, model, data, width, height, options, context },
    page => page.pdf({ format: 'A4', ...options })
  )
}
